import { Component } from "@angular/core";

@Component({
	selector: "caass-scanpoint",
	templateUrl: "./scanpoint.component.html",
})
export class ScanPointComponent {}
